import { gql, useMutation } from "@apollo/client";
import { InputField } from "@src/components/fields";
import { AsyncSelect } from "@src/components/fields/AsyncSelect";
import { StaticSelectField } from "@src/components/fields/StaticSelect";
import Form from "@src/components/Form";
import PackageSelect, { type PackageOption } from "@src/components/select/PackageSelect";
import {
    type GQLCreateLicenceMutation,
    type GQLCreateLicenceMutationVariables,
    type GQLCreateLicencesInput,
    GQLLicenceType,
} from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

interface FormValues extends GQLCreateLicencesInput {
    packageInput: PackageOption;
}

const createLicenceMutation = gql`
    mutation CreateLicence($input: CreateLicencesInput!) {
        createLicences(input: $input) {
            id
        }
    }
`;

const AddForm: FC<PropsWithChildren> = () => {
    const intl = useIntl();
    const [createMutation] = useMutation<GQLCreateLicenceMutation, GQLCreateLicenceMutationVariables>(createLicenceMutation);

    const submit = ({ packageInput, count, ...input }: FormValues) => {
        return createMutation({
            variables: {
                input: {
                    ...input,
                    count: Number(count),
                    packageId: packageInput.id,
                },
            },
        });
    };

    const licenceTypeOptions = [
        { value: GQLLicenceType.Printed, label: intl.formatMessage({ id: "reviermanager.codes.type.printed", defaultMessage: "Printed" }) },
        { value: GQLLicenceType.Online, label: intl.formatMessage({ id: "reviermanager.codes.type.online", defaultMessage: "Online" }) },
    ];

    return (
        <Form
            mode="add"
            onSubmit={submit}
            title={intl.formatMessage({ id: "reviermanager.codes.form.add.title", defaultMessage: "Neue Codes erstellen" })}
        >
            <InputField type="number" name="count" label={intl.formatMessage({ id: "reviermanager.code.count", defaultMessage: "Anzahl" })} />
            <StaticSelectField
                name="type"
                label={intl.formatMessage({ id: "reviermanager.code.type", defaultMessage: "Typ" })}
                options={licenceTypeOptions}
            />
            <AsyncSelect
                name="packageInput"
                label={intl.formatMessage({ id: "reviermanager.code.package", defaultMessage: "Paket" })}
                component={PackageSelect}
            />
        </Form>
    );
};

export default AddForm;
